import React from 'react';
import { useTranslation } from 'react-i18next';

/** One quiet explanation. Provider credit remains owned by the event card. */
export default function RecommendationExplanation({ recommendation, source }) {
  const { t } = useTranslation('details');
  if (!recommendation || recommendation.origin === 'global') return null;
  let key;
  if (recommendation.origin === 'followed_artist') key = 'artist';
  else if (recommendation.origin === 'followed_venue') key = 'venue';
  else if (recommendation.origin === 'farther') key = 'farther';
  else key = recommendation.centerKind === 'home' ? 'home' : 'device';
  if (source?.name && (key === 'artist' || key === 'venue')) key += 'Named';
  const trip = recommendation.tripLabel;
  if (trip?.kind === 'there' && source) key += 'Trip';
  else if (recommendation.nearHomeWhileAway) key += 'NearHome';
  else if (trip?.kind === 'away' && !source) key = 'away';
  return (
    <p className="mb-1.5 text-xs text-content-secondary">
      {t(`whatsOn.reason.${key}`, { name: source?.name, place: trip?.place })}
    </p>
  );
}
